<template>
  <div>
    <div class="centerx">
      <vs-popup
        class="holamundo"
        v-bind:title="'Ajuda - Envio/Status'"
        :active.sync="popupActivo"
      >
        <div v-html="textoAjuda"></div>
      </vs-popup>
    </div>
    <div class="card card-header list-group-item list-group-item-action active mb-3">
      <h4 class="mb-0">Envio/Status</h4>
      <div
        class="badge bagde-default"
        @click="popupActivo = true"
        style="position: absolute; top: 17px; right: 15px"
      >
        Ajuda <i class="fa fa-question-circle"></i>
      </div>
    </div>
    <div class="card text-center" style="padding:15px;">
      Sua proposta está disponível para envio, clique no botão abaixo para inciar a análise.
      <form style="padding:15px;" class="text-center" @submit="fnCadastra" method="post">
        <h4 class="mb-3">Enviar proposta:</h4>
        <h3 class="mb-2">{{contrato.servicos.abreviacao}} - {{contrato.servicos.titulo}}
          <br><small>{{contrato.codigoContratacao}}</small>
        </h3>
        <table class="table">
            <thead>
                <tr>
                    <th class="text-left">Contratação</th>
                    <th class="text-left" v-if="contrato.contratacoesEVO13 != null">Preenchimento</th>
                    <th class="text-left" v-if="contrato.tsReprovacao">Reprovação</th>
                    <th class="text-left">Status</th>
                    <th class="text-left" v-if="contrato.status == 'Finalizado'">Aprovada</th>
                    <th class="text-left" v-if="contrato.cancelado">Cancelada</th>
                    <th class="text-left" v-if="contrato.tsDownload">Download</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="text-left">{{formatData(contrato.tsContratacao)}}</td>
                    <td class="text-left" v-if="contrato.contratacoesEVO13">{{formatData(contrato.contratacoesEVO13.tsPreenchimento)}}</td>
                    <td class="text-left" v-if="contrato.tsReprovacao">{{formatData(contrato.tsReprovacao)}}</td>
                    <td class="text-left">{{contrato.status}}</td>
                    <td class="text-left" v-if="contrato.status == 'Finalizado'">{{formatData(contrato.tsAprovacao)}}</td>
                    <td class="text-left" v-if="contrato.cancelado">{{formatData(contrato.tsCancelamento)}}</td>
                    <td class="text-left" v-if="contrato.tsDownload">{{formatData(contrato.tsDownload)}}</td>
                </tr>
            </tbody>

        </table>
        <table class="table">
             <tbody>
              <tr v-if="contrato.status == 'Dados reprovados' && contrato.status != 'Em aprovação'">
                <td colspan="7" class="text-left alert-danger" >
                    <h4>Motivos da reprovação </h4>
                    <div v-html="contrato.reprovacaoMotivo"></div>
                </td>
              </tr>
                <tr>
                    <td colspan="3" class="text-left">
                      
                    </td>
                    <td colspan="4" class="text-right">
                        <button 
                       v-if="contrato.status != 'Dados reprovados' && contrato.status != 'Em aprovação' && contrato.status != 'Finalizado'"
                        type="submit" style="min-width:60%;" class="btn btn-success ml-auto">
                          Enviar</button>
                    </td>
                </tr>
            </tbody>
        </table>
      </form>
       <a  type="button" @click="fnImprimir" style="min-width:60%;" class="btn btn-info">
                          Imprimir proposta</a>
      <div class=" text-center" @click="fnDownload()" v-if="contrato.status == 'Finalizado'">
        <i class="icon-download1 i-rounded i-xlarge" style="float:none;"></i>
      </div>

    </div>
  </div>
</template>

<script>
import { getSuccess, clientKey,urlApi } from "../../../global/utils";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";
import { jsPDF } from "jspdf";

export default {
  data() {
    return {
      contrato: {},
      cadastro: {
        tsPreenchimento:null,
        preenchida:true
      },
      cadastroid: null,
       servico: null,
      textoAjuda: null,
      popupActivo: false,
   };
  },components:{
  },

  mounted() {
    this.fnGetContratacao();
  },
  methods: {
    formatData(value) {
      return this.$moment(String(value)).format("DD/MM/YYYY");
    },
    createPDF () {
    let pdfName = 'test'; 
    var doc = new jsPDF();
    doc.text("Hello World", 10, 10);
    doc.save(pdfName + '.pdf');
  },fnImprimir(){
    window.location.href = `/areacliente/contrato/etapa13/imprimir/${this.$route.params.codigoContrato}`;
  },
    async fnGetContratacao(){
      await this.$http
        .get(`contratacao/codigo/${this.$route.params.codigoContrato}/etapa_13`)
        .then((res) => {
          this.contrato = res.data;
          if(res.data.contratacoesEVO13 != null){
            this.cadastro = res.data.contratacoesEVO13
          }
        })
        .catch(() => {});
              await this.$http
        .get(`contratacao/lista/${this.$route.params.codigoContrato}`)
        .then((res) => {
          this.servico = res.data.servicos;
          this.textoAjuda = this.servico.textoAjuda13;
        });


  },
   async fnDownload() {
      const imgUrl =
        urlApi + "Upload/" + this.$route.params.codigoContrato + "/etapa13/";
      window.open(imgUrl + this.contrato.arquivoEstudo);
      await this.$http.put("/contratacao/download/"+this.$route.params.codigoContrato+"/"+this.contrato.contratacaoId)
      .then(() => {
       
      })
      .catch(() => {});
    },

    async fnCadastra(e) {
      e.preventDefault();
      const metodo = this.cadastro.etapaId ? "put" : "post";
      this.cadastro.tsPreenchimento = this.$moment().format("YYYY-MM-DD HH:mm");
      this.cadastro.ContratacaoId = this.contrato.contratacaoId
      const completaUrl = this.cadastro.etapaId
        ? "/" + this.cadastro.etapaId
        : "";
    await this.$http[metodo]("/etapa_13" + completaUrl, this.cadastro)
      .then((res) => {
        this.cadastro = res.data
        getSuccess();
          window.location.reload(true);

      })
      .catch(() => {});
    },
    convertToken(token) {
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );

      return JSON.parse(jsonPayload);
    },
    async fnDeletar(val) {
      var token = localStorage.getItem(clientKey);
      var dataToken = this.convertToken(token);
      await this.$http
        .delete(`/etapa_12/${val}/${dataToken.ClienteId}`)
        .then(() => {
          let i = this.content.map((item) => item.etapaId).indexOf(val);
          this.content.splice(i, 1);
          getSuccess();
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.card-header {
  h4 {
    color: #fff;
    text-align: center;
  }
}
.expand-user {
  width: 120%;
}
</style>